/**
 * Client-side conversation list filters for Messages (field-edition chips).
 */

export const MSG_FILTER_ALL = 'all';
export const MSG_FILTER_UNREAD = 'unread';
export const MSG_FILTER_DIRECT = 'direct';
export const MSG_FILTER_BROADCAST = 'broadcast';

export const MSG_LIST_FILTER_CHIPS = [
  { id: MSG_FILTER_ALL, label: 'All' },
  { id: MSG_FILTER_UNREAD, label: 'Unread' },
  { id: MSG_FILTER_DIRECT, label: 'Direct' },
  { id: MSG_FILTER_BROADCAST, label: 'Club broadcasts' },
];

export function conversationMatchesSearch(conversation, searchTerm, currentUserId, {
  getTitle,
  getSubtitle,
} = {}) {
  const q = String(searchTerm || '').trim().toLowerCase();
  if (!q) return true;
  const title = String(getTitle?.(conversation) || '').toLowerCase();
  const subtitle = String(getSubtitle?.(conversation, currentUserId) || '').toLowerCase();
  return title.includes(q) || subtitle.includes(q);
}

export function conversationMatchesFilter(conversation, filterId = MSG_FILTER_ALL) {
  if (!filterId || filterId === MSG_FILTER_ALL) return true;
  const type = conversation?.conversation_type;
  if (filterId === MSG_FILTER_UNREAD) return (Number(conversation?.unread_count) || 0) > 0;
  if (filterId === MSG_FILTER_DIRECT) return type === 'direct';
  if (filterId === MSG_FILTER_BROADCAST) return type === 'club_announcement';
  return true;
}

export function filterConversations(
  conversations,
  { searchTerm = '', filterId = MSG_FILTER_ALL, currentUserId, getTitle, getSubtitle } = {},
) {
  const list = Array.isArray(conversations) ? conversations : [];
  return list.filter(
    (c) =>
      conversationMatchesFilter(c, filterId)
      && conversationMatchesSearch(c, searchTerm, currentUserId, { getTitle, getSubtitle }),
  );
}
